import React, {lazy, Suspense} from 'react'

const DictionarySinglePageLazy = lazy(() =>
    import('./DictionarySinglePage')
)

const DictionarySinglePage = props => (
    <Suspense fallback={null}>
        <DictionarySinglePageLazy {...props} />
    </Suspense>
)

export default DictionarySinglePage
